import { withDependencies } from '@wix/thunderbolt-ioc'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { ISiteMembersApi, ISiteMembersSideEffects } from '../types'
import { name, SiteMembersApiSymbol } from '../symbols'

export const SiteMembersSideEffects = withDependencies(
	[SiteMembersApiSymbol],
	(siteMembers: ISiteMembersApi): IModelUpdatesHandlersImplementor<ISiteMembersSideEffects> => ({
		featureName: name,
		handlers: {
			onComponentLoaded: async ({ smcollectionId }) => {
				if (smcollectionId) {
					try {
						await siteMembers.getMemberDetails()
					} catch (error) {
						return
					}
				}
			},
		},
	})
)
